module.exports = __webpack_public_path__ + "assets/c30af179079bcb992b1a815d348b89cf.png";